import { FC, useCallback } from 'react'
import { Link, Stack, Typography } from '@mui/material'
import { LoadingButton } from '@mui/lab'

import Title from './Title'
import useIsNavigatingAway from '../hooks/useIsNavigatingAway'
import useAnalytics from '../hooks/useAnalytics'

const SignUpFormEmailInUse: FC = () => {
  const analytics = useAnalytics('sign_up_email_already_in_use_page')

  const isNavigatingAway = useIsNavigatingAway()
  const onContinueToForgottenPassword = useCallback(() => {
    document.querySelector<HTMLInputElement>('#emailAddressAlreadyInUseContinueWithPasswordReset_true')!.checked = true
    document.querySelector<HTMLButtonElement>('#continue')!.click()
    analytics.onOther('continue_to_forgotten_password')
  }, [analytics])
  const onContinueToLogin = useCallback(() => {
    document.querySelector<HTMLButtonElement>('#continue')!.click()
    analytics.onOther('continue_to_login')
  }, [analytics])

  return (
    <Stack spacing={6}>
      <Title>Sign up</Title>
      <Typography component="div" color="error">
        An account is already registered using this email address. Please Sign In instead.
      </Typography>
      <Link sx={{ width: 'fit-content', cursor: 'pointer' }} onClick={onContinueToForgottenPassword}>
        Forgot your password
      </Link>
      <LoadingButton fullWidth onClick={onContinueToLogin} variant="contained" loading={isNavigatingAway}>
        Sign In
      </LoadingButton>
    </Stack>
  )
}

export default SignUpFormEmailInUse
